export const ChartMargins = { top: 10, right: 10, bottom: 30, left: 30 };



// WEBPACK FOOTER //
// ./src/code/UI/UIConstants.ts